import { graphql } from '$lib/graphql';

export const ThoughtPermalinkFragment = graphql(`
	fragment ThoughtPermalink on ThoughtRecord @_unmask {
		slug
		_updatedAt
		_firstPublishedAt
	}
`);
